export { BodyIcon } from './body'
